import { render, staticRenderFns } from "./vehicleQueue.vue?vue&type=template&id=e168bf12"
import script from "./vehicleQueue.vue?vue&type=script&lang=js"
export * from "./vehicleQueue.vue?vue&type=script&lang=js"
import style0 from "./vehicleQueue.vue?vue&type=style&index=0&id=e168bf12&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports